import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react-shared/BuilderUI/utils/twMergeWithCNAndPrefix";

const i18nRoot = "builder_ui.form_block";

interface FormErrorProps {
  formError: unknown;
}

export const FormError = ({ formError }: FormErrorProps) => (
  <div className={classNames("wb-text-center wb-text-red-500")}>
    <div className={classNames("wb-text-lg wb-font-medium")}>
      {t([i18nRoot, "form_not_available"])}
    </div>
    <div className={classNames("wb-text-sm")}>
      {formError
        ? t([i18nRoot, "error_loading_form"])
        : t([i18nRoot, "form_not_found"])}
    </div>
  </div>
);
